module.exports = __webpack_public_path__ + "static/media/adduser.16285f14.svg";